import v1 from "requests/versions/v1.config";

const V1_URL = "/vehicles";

export const getVehiclesV1 = (params) => v1.get(V1_URL, { params });

export const getVehiclePhotosV1 = (vehicleId) =>
  v1.get(`${V1_URL}/${vehicleId}/vehicle_photos?limit=-1`);
